module.exports = __webpack_public_path__ + "img/22.c1a7a601.png";